<dashboardnav>
  
    <cradua-subsubgrouptypecategory
    [subsubgrouptypecategorys]="subsubgrouptypecategorys$ | async"
    (subsubgrouptypecategory)="onSubmitSubSubGroupTypeCategory($event)"
    (deleteSubSubGroupTypeCategoryEvent)="onDeleteSubSubGroupTypeCategory($event)"
    *ngIf="(isLoadingSubSubGroupTypeCategory$ | async ) === false"
    >
  </cradua-subsubgrouptypecategory>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoadingSubSubGroupTypeCategory$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
  